import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: 776px 1fr;
	gap: 24px;

	> div {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: flex;
		flex-direction: column;
	}
`;

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const MainTitle = styled.h1`
	${({ theme }) => theme.typography.headlines.h3}
`;

export const Title = styled.h2`
	${({ theme }) => theme.typography.headlines.h4}
`;

export const OrangeText = styled.span`
	${({ theme }) => theme.typography.headlines.h4}
	color: ${({ theme }) => theme.colors.primary.medium};
`;

export const Text = styled.p`
	${({ theme }) => theme.typography.label.medium}
	color: ${({ theme }) => theme.colors.body.light};
	line-height: 28px;
`;

export const FlexDiv = styled.div<{ $alignItemsMobile: string }>`
	display: flex;
	align-items: center;
	gap: 24px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: column;
		align-items: ${({ $alignItemsMobile }) => $alignItemsMobile};
		gap: 12px;
	}
`;

export const Accessories = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
`;

export const CarData = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 32px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

export const Logo = styled.img`
	width: 104px;
	height: 64px;
	object-fit: contain;
`;

export const ExternalLink = styled.a`
	color: ${({ theme }) => theme.colors.primary.medium};

	&:hover {
		color: ${({ theme }) => theme.colors.primary.light};
	}
`;

export const PixContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	overflow-wrap: anywhere;

	> p {
		margin-top: 10px;
	}

	p:nth-child(4) {
		cursor: copy;
	}
`;

export const PixCopyPasteConfirm = styled.p`
	color: red;
	font-weight: bold;
`;

export const DescriptionContainer = styled.div``;

export const CopiaECola = styled.p`
	border: 1px solid;
`;

export const PixInstruction = styled.div`
	padding: 32px 20px;
`;


export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  width: 100%;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  text-align: left;
`;

export const StatusText = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #000;
  margin: 0;
`;

export const OfferLabel = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
`;

export const OfferValue = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: #e9630f; /* Laranja */
`;

export const DateLabel = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
`;

export const DateValue = styled.span`
  font-size: 0.95rem;
  font-weight: 700;
  color: #000;
`;

export const ActionButton = styled.button`
  background-color: #e9630f;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  width: 100%;
  transition: all 0.2s ease-in-out;

 transition: background-color 0.25s ease, 
              color 0.25s ease,
              border-color 0.25s ease;

  &:hover {
    background-color: #111111;
    color: #fff;
    border-color: #111111;
  }
`;

export const ActionButtonHover = styled.button`
  background-color: #fff;
  color: #e9630f;
  border: 2px solid #e9630f;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  width: 100%;
  
  transition: background-color 0.25s ease, 
              color 0.25s ease,
              border-color 0.25s ease;

  &:hover {
    background-color: #111111;
    color: #fff;
    border-color: #111111;
  }
`;


export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ececec;
  margin: 12px 0;
`;

export const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SectionTitle = styled.h4`
  font-size: 0.9rem;
  font-weight: 600;
  color: #000;
  margin: 0 0 6px 0;
`;